export const defaultCurrency = '$';
export const defaultWeightUnits = 'lb';
